// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Gv-z","tooltipWrapper":"Hv-z","icon":"Iv-z","tooltip":"Jv-z","content":"Kv-z"};